/* eslint-disable no-param-reassign */
import { jsx } from 'slate-hyperscript';

import { COLORS, COLORS_REVERSE } from '../../../constants/colors';
import { FONT_SIZES, FONT_SIZES_REVERSE } from '../../../constants/editorConst';

export const deserializeNodes = (el, marks = {}) => {
  if (el.nodeType === Node.TEXT_NODE) {
    return el.textContent;
  }

  if (el.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  let children = Array.from(el.childNodes).map(child =>
    deserializeNodes(child, marks),
  );

  if (children.length === 0) {
    children = [{ text: '' }];
  }

  switch (el.nodeName) {
    // Elements:
    case 'BODY':
      return jsx('fragment', {}, children);
    case 'BR':
      return '\n';
    case 'BLOCKQUOTE':
      return jsx('element', { type: 'quote' }, children);
    case 'UL':
      return jsx('element', { type: 'bulleted-list' }, children);
    case 'OL':
      return jsx('element', { type: 'numbered-list' }, children);
    case 'LI':
      return jsx('element', { type: 'list-item' }, children);
    case 'IMG':
      return jsx('element', { type: 'image', url: el.getAttribute('src') }, [
        { text: '' },
      ]);
    case 'DIV':
      if (el.className.includes('align--center')) {
        return jsx('element', { type: 'align--center' }, children);
      }
      if (el.className.includes('align--right')) {
        return jsx('element', { type: 'align--right' }, children);
      }
      if (el.className.includes('align--left')) {
        return jsx('element', { type: 'align--left' }, children);
      }

      return jsx('element', { type: 'paragraph' }, children);
    case 'G-LINK':
      return jsx(
        'element',
        {
          type: 'link',
          url: el.getAttribute('uid'),
        },
        [{ text: el.getAttribute('value') }],
      );
    case 'G-MENTION':
      return jsx(
        'element',
        {
          type: 'mention',
          character: el.getAttribute('value'),
        },
        [{ text: '' }],
      );
    case 'G-TAG':
      return jsx(
        'element',
        {
          type: 'hashtag',
          character: el.getAttribute('value'),
        },
        [{ text: '' }],
      );

    // Leafs:
    case 'STRONG':
      marks.bold = true;
      return { text: el.textContent, ...marks };
    case 'EM':
      marks.italic = true;
      return { text: el.textContent, ...marks };
    case 'DEL':
      marks.strikethrough = true;
      return { text: el.textContent, ...marks };
    case 'SPAN':
      if (el.className === 'underline') {
        marks.underline = true;
        return { text: el.textContent, ...marks };
      }
      if (Object.values(COLORS).includes(el.className)) {
        marks.color = COLORS_REVERSE[el.className];
        return { text: el.textContent, ...marks };
      }
      if (Object.values(FONT_SIZES).includes(el.className)) {
        marks.fontSize = +FONT_SIZES_REVERSE[el.className];
        return {
          text: el.textContent,
          ...marks,
        };
      }
      return el.textContent;
    default:
      return el.textContent;
  }
};

export const deserialize = str => {
  const domNodes = new DOMParser().parseFromString(str, 'text/html');

  return deserializeNodes(domNodes.body);
};
